<template>
    <table class="dark-table">
        <tbody>
            <th>Exam</th>
            <th>Last Name</th>
            <th>First Name</th>
            <th>Correct</th>
            <th>Total Questions</th>
            <th>Percentage</th>
            <th>Status</th>
            <tr v-for="a in assessments">
                <td> {{ a.name }}</td>
                <td> {{ a.candidateLastName }}</td>
                <td> {{ a.candidateFirstName }}</td>
                <td> {{ a.correct }}</td>
                <td> {{ a.totalQuestions }}</td>
                <td> {{ a.correct / a.totalQuestions * 100 }}%</td>
                <td> {{ a.status }}</td>
            </tr>
            <tr v-if="assessments && assessments < 1">
                <td colspan="7" class="empty-candidates">No candidates completed assessments.</td>
            </tr>
        </tbody>
    </table>
</template>
<script>
export default {
    name: 'CandidateTable',
    props: ['assessments'],
    data() {        
        return {

        }
    },
    mounted() {

    },
    methods: {

    }
}
</script>
<style scoped>
.dark-table {
    background-color: #292929; /* Dark gray background */
    color: #fff; /* White text color */
    border-collapse: collapse; /* Remove default cell spacing */
    width: 100%;
}

.dark-table th,
.dark-table td {
    padding: 10px; /* Add padding to cells */
    border: 1px solid #383838; /* Dark border for cells */
}

.dark-table th {
    background-color: #3f3f3f; /* Darker gray for table header */
}

.dark-table tbody tr:nth-child(even) {
    background-color: #333; /* Darker background for even rows */
}

.dark-table tbody tr:hover {
    background-color: #4f4f4f; /* Darker background for hover effect */
}

/* Hint of purple */
.dark-table th,
.dark-table td {
    border: 1px solid #383838; /* Dark border for cells */
}

.dark-table th {
    background-color: #27202c; /* Purple background for table header */
}

.dark-table tbody tr:nth-child(even) {
    background-color: #363438; /* Purple background for even rows */
}

.dark-table tbody tr:hover {
    background-color: #2b1542; /* Darker purple background for hover effect */
}

@media screen and (max-width: 576px) {
  .dark-table {
    min-width: 200px;
  }
}

.empty-candidates {
    /* Set background image */
    background-image: url('../../../assets/empty-candidates.png');

    /* Adjust background properties */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 300px;
}
</style>